// extracted by mini-css-extract-plugin
export default {"wapperTable":"Table_wapperTable__rj6sx","tableMain":"Table_tableMain__tnvVh","rowHeadLine":"Table_rowHeadLine__9Gj+b"};